import { NameCell } from './NameCell';
import { CountCell } from './CountCell';
import { ColorIconCell } from './ColorIconCell';
import { PercentageCell } from './PercentageCell';
import { AudienceCount } from '../../domain';

type RowProps = {
  value: AudienceCount;
  total: number;
  index: number;
  hasMeterChart?: boolean;
};

export const Row = ({ value, total, index, hasMeterChart }: RowProps) => {
  const { name, count } = value;

  return (
    <>
      <ColorIconCell rowIndex={index} isEnabled={hasMeterChart} />
      <NameCell name={name} rowIndex={index} />
      <PercentageCell count={count} total={total} rowIndex={index} isEnabled={hasMeterChart} />
      <CountCell count={count} rowIndex={index} />
    </>
  );
};
